import { TabPanel, TabView } from "primereact/tabview";
import React, { useEffect, useState } from "react";
import { Badge, Card, Table } from "react-bootstrap";
import {
  CustomOutlinedDisabledCurrencyField,
  CustomOutlinedDisabledTextField,
} from "../../../../../../partials/content/Forms";
import { formatDate } from "../../../../../../utils/utils";
import { getContract } from "../../../../../../services/inventory/procurementService";
import { Accordion, AccordionTab } from "primereact/accordion";
import { Typography } from "@material-ui/core";
import NumberFormat from "react-number-format";
import Illustration from "../../../../../../partials/content/Illustration";
import BootstrapTooltip from "../../../../../../partials/content/BootstrapTooltip";
import { Timeline } from "primereact/timeline";
import { Step, StepLabel, Stepper } from "@material-ui/core";
import { Editor } from "primereact/editor";
import parse from "html-react-parser";

function ContractBasicInfo({
  contractID = 0,
  contractImp = {
    ID: 0,
    contractCode: "",
    vendor: {
      vendorName: "",
    },
    currency: {
      currencyCode: "",
    },
    warehouse: { warehouseName: "" },
    poDeliveryAddress: { address: "" },
    contractItems: [],
    contractAddCost: [],
    approvalStatusDesc: "",
    note: "",
    toc: "",
  },
  approvalProcessImp = [],
  approvalStepsImp = [],
  approvalActiveStepImp = 0,
}) {
  const [activeIndex, setActiveIndex] = useState(0);
  const [contract, setContract] = useState(contractImp);
  const [approvalProcess, setApprovalProcess] = useState(approvalProcessImp);
  const [approvalSteps, setApprovalSteps] = useState(approvalStepsImp);
  const [approvalActiveStep, setApprovalActiveStep] = useState(
    approvalActiveStepImp
  );
  useEffect(() => {
    if (contractID > 0) {
      getContractData(contractID);
    }
  }, [contractID]);
  return (
    <React.Fragment>
      <div className="tabview">
        <div className="card">
          <TabView className="tabview" scrollable>
            <TabPanel header="Contract Main" rightIcon="fas fa-th-large">
              <div className="row mb-3">
                <div className="col-sm-12 col-md-12 col-lg-12">
                  <Card>
                    <Card.Header>
                      <i className="fas fa-window-maximize"></i>
                      <span>
                        <strong>Contract Header</strong>
                      </span>
                      <Badge
                        className="float-right ml-1"
                        variant={
                          contract.contractStatus === 2
                            ? "danger"
                            : contract.contractStatus === 1
                            ? "success"
                            : null
                        }
                      >
                        {contract.contractStatus !== 0
                          ? "Contract " + contract.contractStatusDesc
                          : null}
                      </Badge>
                    </Card.Header>
                    <Card.Body>
                      <div className="row">
                        <div className="col-sm-6 col-md-6 col-lg-6">
                          <CustomOutlinedDisabledTextField
                            label="Contract ID"
                            value={contract.contractCode}
                          />
                          <CustomOutlinedDisabledTextField
                            label="Vendor Name"
                            value={contract.vendor.vendorName}
                          />
                          <div className="row">
                            <div className="col-sm-12 col-md-12 col-lg-6">
                              <CustomOutlinedDisabledTextField
                                label="Currency"
                                value={contract.currency.currencyCode}
                              />
                            </div>
                            <div className="col-sm-12 col-md-12 col-lg-6">
                              <CustomOutlinedDisabledCurrencyField
                                label="Exchange Rate To Base Currency"
                                value={contract.exchangeRate}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-sm-6 col-md-6 col-lg-6">
                          <div className="row">
                            <div className="col-sm-12 col-md-12 col-lg-12">
                              <CustomOutlinedDisabledTextField
                                label="Agreement Date"
                                value={formatDate(contract.agreementDate)}
                              />
                            </div>
                            <div className="col-sm-6 col-md-6 col-lg-6">
                              <CustomOutlinedDisabledTextField
                                label="Validity Start Date"
                                value={formatDate(contract.validityStartDate)}
                              />
                            </div>
                            <div className="col-sm-6 col-md-6 col-lg-6">
                              <CustomOutlinedDisabledTextField
                                label="Validity End Date"
                                value={formatDate(contract.validityEndDate)}
                              />
                            </div>
                          </div>
                          <CustomOutlinedDisabledTextField
                            label="Default Warehouse Name"
                            value={contract.warehouse.warehouseName}
                          />
                          <CustomOutlinedDisabledTextField
                            label="Approval Status"
                            value={contract.approvalStatusDesc}
                          />
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                </div>
              </div>
              <div className="accordion">
                <div className="card">
                  <Accordion
                    className="accordion"
                    activeIndex={activeIndex}
                    onTabChange={(e) => setActiveIndex(e.index)}
                  >
                    <AccordionTab
                      header={
                        <React.Fragment>
                          <i className="fas fa-sitemap"></i>
                          <span>
                            <strong>Contract Items</strong>
                          </span>
                        </React.Fragment>
                      }
                    >
                      <div className="row">
                        <div className="col-sm-12 col-md-12 col-lg-12">
                          <div className="row mb-3">
                            <div className="col-sm-12 col-md-12 col-lg-12">
                              <div className="card">
                                <Table
                                  striped
                                  borderless
                                  size="sm"
                                  responsive="xl"
                                >
                                  {contract.contractItems &&
                                  contract.contractItems.length > 0 ? (
                                    <thead>
                                      <tr>
                                        <th style={{ width: "30%" }}>
                                          <Typography className="mx-1 kt-font-bolder">
                                            Item Name
                                          </Typography>
                                        </th>
                                        <th style={{ width: "10%" }}>
                                          <Typography className="mx-1 kt-font-bolder">
                                            Quantity
                                          </Typography>
                                        </th>
                                        <th style={{ width: "15%" }}>
                                          <Typography className="mx-1 kt-font-bolder">
                                            Unit
                                          </Typography>
                                        </th>
                                        <th style={{ width: "20%" }}>
                                          <Typography className="mx-1 kt-font-bolder text-right">
                                            Unit Price
                                          </Typography>
                                        </th>
                                        <th style={{ width: "25%" }}>
                                          <Typography className="mx-1 kt-font-bolder text-right">
                                            Total Price
                                          </Typography>
                                        </th>
                                      </tr>
                                    </thead>
                                  ) : null}
                                  <tbody>
                                    {contract.contractItems &&
                                    contract.contractItems.length > 0 ? (
                                      contract.contractItems.map(
                                        (item, index) => (
                                          <tr
                                            key={index}
                                            className="border-top"
                                          >
                                            <td>
                                              <Typography className="mx-1 my-1">
                                                {item.itemType > 0 ? (
                                                  <span>
                                                    <BootstrapTooltip
                                                      title={item.itemTypeName}
                                                    >
                                                      <span className="mr-2">
                                                        <i
                                                          className={
                                                            item.itemType === 1
                                                              ? "fas fa-boxes text-success"
                                                              : item.itemType ===
                                                                2
                                                              ? "fas fa-tools text-primary"
                                                              : item.itemType ===
                                                                3
                                                              ? "fas fa-building text-info"
                                                              : item.itemType ===
                                                                4
                                                              ? "fas fa-boxes text-warning"
                                                              : item.itemType ===
                                                                5
                                                              ? "fas fa-boxes text-danger"
                                                              : null
                                                          }
                                                        ></i>
                                                      </span>
                                                    </BootstrapTooltip>
                                                    <span>
                                                      {item.itemCode}{" "}
                                                      {item.itemName}
                                                    </span>
                                                  </span>
                                                ) : (
                                                  <React.Fragment>
                                                    {item.itemCode}{" "}
                                                    {item.itemName}
                                                  </React.Fragment>
                                                )}
                                              </Typography>
                                            </td>
                                            <td>
                                              <Typography className="mx-1 my-1">
                                                {item.targetQty}
                                              </Typography>
                                            </td>
                                            <td>
                                              <Typography className="mx-1 my-1">
                                                {item.itemUom.uomName}
                                              </Typography>
                                            </td>
                                            <td>
                                              <Typography
                                                component="div"
                                                className="mx-1 my-1"
                                              >
                                                <NumberFormat
                                                  value={item.unitPrice}
                                                  displayType={"text"}
                                                  thousandSeparator={true}
                                                  decimalScale={2}
                                                  renderText={(value) => (
                                                    <div className="float-right">
                                                      {contract.currencyCode}{" "}
                                                      {value}
                                                    </div>
                                                  )}
                                                />
                                              </Typography>
                                            </td>
                                            <td>
                                              <Typography
                                                component="div"
                                                className="mx-1 my-1"
                                              >
                                                <NumberFormat
                                                  value={item.totalPrice}
                                                  displayType={"text"}
                                                  thousandSeparator={true}
                                                  decimalScale={2}
                                                  renderText={(value) => (
                                                    <div className="float-right">
                                                      {contract.currencyCode}{" "}
                                                      {value}
                                                    </div>
                                                  )}
                                                />
                                              </Typography>
                                            </td>
                                          </tr>
                                        )
                                      )
                                    ) : (
                                      <tr>
                                        <td
                                          className="text-center py-3"
                                          colSpan="5"
                                        >
                                          <Illustration
                                            imageSource="INVIFO Procurement.png"
                                            guidance="You don't have any Contract items yet"
                                            guidanceLeftIcon="fas fa-info-circle kt-font-warning"
                                            size="sm"
                                          ></Illustration>
                                        </td>
                                      </tr>
                                    )}
                                  </tbody>
                                </Table>
                              </div>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-sm-6 col-md-6 col-lg-6 mb-3 mb-md-0">
                              <Card>
                                <Card.Body>
                                  <div className="card">
                                    <Table
                                      striped
                                      borderless
                                      size="sm"
                                      responsive="xl"
                                    >
                                      {contract.contractAddCost &&
                                      contract.contractAddCost.length > 0 ? (
                                        <thead>
                                          <tr>
                                            <th style={{ width: "60%" }}>
                                              <Typography className="mx-1 kt-font-bolder">
                                                Cost Name
                                              </Typography>
                                            </th>
                                            <th style={{ width: "40%" }}>
                                              <Typography className="mx-1 kt-font-bolder">
                                                Cost Price
                                              </Typography>
                                            </th>
                                          </tr>
                                        </thead>
                                      ) : null}
                                      <tbody>
                                        {contract.contractAddCost &&
                                        contract.contractAddCost.length > 0 ? (
                                          contract.contractAddCost.map(
                                            (item, index) => {
                                              return (
                                                <tr
                                                  key={index}
                                                  className="border-top"
                                                >
                                                  <td>
                                                    <Typography className="mx-1 my-1">
                                                      {item.itemName}
                                                    </Typography>
                                                  </td>
                                                  <td>
                                                    <Typography
                                                      component="div"
                                                      className="mx-1 my-1"
                                                    >
                                                      <NumberFormat
                                                        value={item.costPrice}
                                                        displayType={"text"}
                                                        thousandSeparator={true}
                                                        decimalScale={2}
                                                        renderText={(value) => (
                                                          <div className="float-right">
                                                            {
                                                              contract.currencyCode
                                                            }{" "}
                                                            {value}
                                                          </div>
                                                        )}
                                                      />
                                                    </Typography>
                                                  </td>
                                                </tr>
                                              );
                                            }
                                          )
                                        ) : (
                                          <tr>
                                            <td
                                              className="text-center"
                                              colSpan="2"
                                            >
                                              <Illustration
                                                guidance="No additional cost"
                                                guidanceLeftIcon="fas fa-info-circle kt-font-success"
                                              ></Illustration>
                                            </td>
                                          </tr>
                                        )}
                                      </tbody>
                                    </Table>
                                  </div>
                                </Card.Body>
                                <Card.Footer>
                                  <Table borderless size="sm" responsive="xl">
                                    <tbody>
                                      <tr>
                                        <td style={{ width: "50%" }}>
                                          <Typography className="kt-font-bolder">
                                            Additional Cost Total
                                          </Typography>
                                        </td>
                                        <td style={{ width: "0%" }}></td>
                                        <td style={{ width: "0%" }}></td>
                                        <td style={{ width: "50%" }}>
                                          <Typography
                                            component="div"
                                            className="kt-font-bolder"
                                          >
                                            <NumberFormat
                                              value={contract.addCostTotal}
                                              displayType={"text"}
                                              thousandSeparator={true}
                                              decimalScale={2}
                                              renderText={(value) => (
                                                <div className="float-right">
                                                  {contract.currencyCode}{" "}
                                                  {value}
                                                </div>
                                              )}
                                            />
                                          </Typography>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </Table>
                                </Card.Footer>
                              </Card>
                            </div>
                            <div className="col-sm-6 col-md-6 col-lg-6">
                              <Card>
                                <Card.Body className="pb-0">
                                  <Table borderless size="sm" responsive="xl">
                                    <tbody>
                                      <tr className="border-bottom">
                                        <td style={{ width: "50%" }}>
                                          <Typography className="mb-3 kt-font-bolder">
                                            Sub Total
                                          </Typography>
                                        </td>
                                        <td style={{ width: "0%" }}></td>
                                        <td style={{ width: "0%" }}></td>
                                        <td style={{ width: "50%" }}>
                                          <Typography
                                            component="div"
                                            className="mb-3 kt-font-bolder"
                                          >
                                            <NumberFormat
                                              value={contract.subTotal}
                                              displayType={"text"}
                                              thousandSeparator={true}
                                              decimalScale={2}
                                              renderText={(value) => (
                                                <div className="float-right">
                                                  {
                                                    contract.currency
                                                      .currencyCode
                                                  }{" "}
                                                  {value}
                                                </div>
                                              )}
                                            />
                                          </Typography>
                                        </td>
                                      </tr>
                                      <tr className="border-bottom">
                                        <td>
                                          <Typography className="my-3">
                                            Additional Cost
                                          </Typography>
                                        </td>
                                        <td></td>
                                        <td></td>
                                        <td>
                                          <Typography
                                            component="div"
                                            className="my-3"
                                          >
                                            <NumberFormat
                                              value={contract.addCostTotal}
                                              displayType={"text"}
                                              thousandSeparator={true}
                                              decimalScale={2}
                                              renderText={(value) => (
                                                <div className="float-right">
                                                  {contract.currencyCode}{" "}
                                                  {value}
                                                </div>
                                              )}
                                            />
                                          </Typography>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </Table>
                                </Card.Body>
                                <Card.Footer>
                                  <Table borderless size="sm" responsive="xl">
                                    <tbody>
                                      <tr>
                                        <td style={{ width: "50%" }}>
                                          <Typography
                                            variant="h6"
                                            className="kt-font-bolder"
                                          >
                                            Grand Total
                                          </Typography>
                                        </td>
                                        <td style={{ width: "0%" }}></td>
                                        <td style={{ width: "0%" }}></td>
                                        <td style={{ width: "50%" }}>
                                          <Typography
                                            variant="h6"
                                            component="div"
                                            className="kt-font-bolder"
                                          >
                                            <NumberFormat
                                              value={contract.grandTotal}
                                              displayType={"text"}
                                              thousandSeparator={true}
                                              decimalScale={2}
                                              renderText={(value) => (
                                                <div className="float-right">
                                                  {contract.currencyCode}{" "}
                                                  {value}
                                                </div>
                                              )}
                                            />
                                          </Typography>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </Table>
                                </Card.Footer>
                              </Card>
                            </div>
                          </div>
                        </div>
                      </div>
                    </AccordionTab>
                  </Accordion>
                </div>
              </div>
            </TabPanel>
            <TabPanel header="Addresses" rightIcon="fas fa-map-marked-alt">
              <div className="row mb-3">
                <div className="col-sm-12 col-md-12 col-lg-12">
                  <Card>
                    <Card.Header>
                      <i className="fas fa-map-marked-alt"></i>
                      <span>
                        <strong>Vendor Address</strong>
                      </span>
                    </Card.Header>
                    <Card.Body>
                      <div className="row">
                        <div className="col-sm-6 col-md-6 col-lg-6">
                          <CustomOutlinedDisabledTextField
                            label="Address"
                            value={contract.address}
                          />
                          <CustomOutlinedDisabledTextField
                            label="City"
                            value={contract.city}
                          />
                          <CustomOutlinedDisabledTextField
                            label="Province / State"
                            value={contract.province}
                          />
                        </div>
                        <div className="col-sm-6 col-md-6 col-lg-6">
                          <CustomOutlinedDisabledTextField
                            label="Phone Number"
                            value={contract.addressPhone}
                          />
                          <CustomOutlinedDisabledTextField
                            label="Email"
                            value={contract.addressEmail}
                          />
                          <CustomOutlinedDisabledTextField
                            label="Postal Code"
                            value={contract.postalCode}
                          />
                        </div>
                        <div className="col-sm-12 col-md-12 col-lg-12">
                          <CustomOutlinedDisabledTextField
                            label="Country"
                            value={contract.countryName}
                          />
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12 col-md-12 col-lg-12">
                  <Card>
                    <Card.Header>
                      <i className="fas fa-map-marked-alt"></i>
                      <span>
                        <strong>Shipping Address</strong>
                      </span>
                    </Card.Header>
                    <Card.Body>
                      <div className="row">
                        <div className="col-sm-6 col-md-6 col-lg-6">
                          <CustomOutlinedDisabledTextField
                            label="Address"
                            value={contract.poDeliveryAddress.address}
                          />
                          <CustomOutlinedDisabledTextField
                            label="City"
                            value={contract.poDeliveryAddress.city}
                          />
                          <CustomOutlinedDisabledTextField
                            label="Province / State"
                            value={contract.poDeliveryAddress.province}
                          />
                        </div>
                        <div className="col-sm-6 col-md-6 col-lg-6">
                          <CustomOutlinedDisabledTextField
                            label="Phone Number"
                            value={contract.poDeliveryAddress.addressPhone}
                          />
                          <CustomOutlinedDisabledTextField
                            label="Email"
                            value={contract.poDeliveryAddress.addressEmail}
                          />
                          <CustomOutlinedDisabledTextField
                            label="Postal Code"
                            value={contract.poDeliveryAddress.postalCode}
                          />
                        </div>
                        <div className="col-sm-12 col-md-12 col-lg-12">
                          <CustomOutlinedDisabledTextField
                            label="Country"
                            value={contract.poDeliveryAddress.countryName}
                          />
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                </div>
              </div>
            </TabPanel>
            <TabPanel
              header={`Note, Terms & Conditions`}
              rightIcon="fas fa-sticky-note"
            >
              <div className="row mb-3">
                <div className="col-sm-12 col-md-12 col-lg-12">
                  <Card>
                    <Card.Header>
                      <i className="fas fa-sticky-note"></i>
                      <span>
                        <strong>Note</strong>
                      </span>
                    </Card.Header>
                    <Card.Body>
                      <Editor
                        style={{ height: "200px", width: "100%" }}
                        value={contract.note}
                        placeholder="Type your notes here..."
                        readOnly={true}
                        className="editor-grey"
                      />
                    </Card.Body>
                  </Card>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12 col-md-12 col-lg-12">
                  <Card>
                    <Card.Header>
                      <i className="fas fa-sticky-note"></i>
                      <span>
                        <strong>Terms & Conditions</strong>
                      </span>
                    </Card.Header>
                    <Card.Body>
                      <Editor
                        style={{ height: "200px", width: "100%" }}
                        value={contract.toc}
                        placeholder="Type your terms & conditions here..."
                        readOnly={true}
                        className="editor-grey"
                      />
                    </Card.Body>
                  </Card>
                </div>
              </div>
            </TabPanel>
            {approvalProcess.length ? (
              <TabPanel
                header="Approval Flow"
                rightIcon="fas fa-file-signature"
              >
                {approvalSteps.length ? (
                  <Stepper activeStep={approvalActiveStep} alternativeLabel>
                    <Step>
                      <StepLabel
                        optional={
                          <Typography align="center" variant="body2">
                            INITIATED
                          </Typography>
                        }
                      >
                        Document Approval
                      </StepLabel>
                    </Step>
                    {approvalSteps.map((label, index) => {
                      const stepProps = {};
                      const labelProps = {};
                      if (label.level < contract.approvalProcess.level)
                        labelProps.optional = (
                          <Typography
                            align="center"
                            variant="body2"
                            className="text-success"
                          >
                            APPROVED
                          </Typography>
                        );
                      if (
                        label.approvalID ===
                          contract.approvalProcess.approvalID &&
                        label.level === contract.approvalProcess.level
                      ) {
                        if (contract.approvalProcess.statusID === 1) {
                          labelProps.error = false;
                          labelProps.optional = (
                            <Typography align="center" variant="body2">
                              IN REVIEW
                            </Typography>
                          );
                        } else if (contract.approvalProcess.statusID === 2) {
                          labelProps.error = false;
                          stepProps.completed = true;
                          labelProps.optional = (
                            <Typography
                              align="center"
                              variant="body2"
                              className="text-success"
                            >
                              APPROVED
                            </Typography>
                          );
                        } else if (contract.approvalProcess.statusID === 3) {
                          labelProps.error = true;
                          labelProps.optional = (
                            <Typography
                              align="center"
                              variant="body2"
                              className="text-danger"
                            >
                              REJECTED
                            </Typography>
                          );
                        }
                      }
                      return (
                        <Step key={index} {...stepProps}>
                          <StepLabel {...labelProps}>
                            {label.userGroup.groupName}
                          </StepLabel>
                        </Step>
                      );
                    })}
                  </Stepper>
                ) : null}
                <div className="row">
                  <div className="col-sm-12 col-md-12 col-lg-12">
                    <Card>
                      <Card.Header>
                        <i className="fas fa-history"></i>
                        <span>
                          <strong>Approval Flow History</strong>
                        </span>
                      </Card.Header>
                      <Card.Body>
                        <Timeline
                          value={approvalProcess}
                          opposite={(item) => {
                            return (
                              <div>
                                {item.statusDesc}
                                {item.statusID === 2 || item.statusID === 3 ? (
                                  <React.Fragment>
                                    <br />
                                    <strong>Note :</strong>
                                    <br />
                                    {parse(item.note)}
                                  </React.Fragment>
                                ) : null}
                              </div>
                            );
                          }}
                          content={(item) => {
                            return (
                              <small className="text-muted">
                                {formatDate(item.actionDate, true)}
                              </small>
                            );
                          }}
                          marker={(item) => {
                            if (item.statusID === 0) {
                              return (
                                <span className="custom-timeline-marker bg-info">
                                  <i className="fas fa-play-circle"></i>
                                </span>
                              );
                            } else if (item.statusID === 1) {
                              return (
                                <span className="custom-timeline-marker bg-warning">
                                  <i className="fas fa-clock"></i>
                                </span>
                              );
                            } else if (item.statusID === 2) {
                              return (
                                <span className="custom-timeline-marker bg-success">
                                  <i className="fas fa-check-circle"></i>
                                </span>
                              );
                            } else if (item.statusID === 3) {
                              return (
                                <span className="custom-timeline-marker bg-danger">
                                  <i className="fas fa-times-circle"></i>
                                </span>
                              );
                            } else {
                              return (
                                <span className="custom-timeline-marker bg-dark">
                                  <i className="fas fa-question-circle"></i>
                                </span>
                              );
                            }
                          }}
                        />
                      </Card.Body>
                    </Card>
                  </div>
                </div>
              </TabPanel>
            ) : (
              <TabPanel
                header="Approval Flow"
                rightIcon="fas fa-file-signature"
                disabled
              ></TabPanel>
            )}
          </TabView>
        </div>
      </div>
    </React.Fragment>
  );

  async function getContractData(contractID = 0) {
    const response = await getContract(contractID);
    const { data } = response.data;
    setContract(data.contract);
    setApprovalProcess(data.approvalProcess);
    setApprovalSteps(data.contract.approvalProcess.approval.approvalValue);
    setApprovalActiveStep(data.contract.approvalProcess.level);
  }
}

export default ContractBasicInfo;
